import React, { useState } from "react";
import "./navbar.css";
import { DashboardRoutesLinks, RoutesLink } from "../../router/RoutesLink.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  about_us,
  logo,
} from "../../pages/LandingPage/components/SvgIcon";
import MobileNavbar from "./Components/MobileNavbar.js";
import LoginHeaderContainer from "./Components/LoginHeaderContainer.js";
import DesktopNavbarList from "./Components/DesktopNavbarList.js";
import arrowIcon from "../../assets/Images/icons/rightArrowIcon.svg";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenu, setmobileMenu] = useState(false);

  const DashboardMenuItems = [{
    link: DashboardRoutesLinks?.dashboard,
    title: "Dashboard",
  },
  {
    link: DashboardRoutesLinks?.myLoans,
    title: "My Loans",
  },
  {
    link: DashboardRoutesLinks?.Support,
    title: "support",
  },

  ]
  const menuItems = [
    { link: RoutesLink?.AboutUs, title: "About Us", icon: about_us },
    { link: RoutesLink?.CreditTools, title: "Credit Tools", icon: about_us },
    {
      link: RoutesLink?.LendingPartners,
      title: "Lending Partners",
      icon: about_us,
    },
    { link: RoutesLink?.Support, title: "Support", icon: about_us },
    { link: RoutesLink?.Blogs, title: "Blogs", icon: about_us },
    { link: RoutesLink?.LoanProducts, title: "Loan Products", icon: about_us },
    { link: RoutesLink?.Contact, title: "Contact", icon: about_us },
  ];

  return (
    <>
      <div className="desktop-header">
        <div className="logo">
          <span onClick={() => navigate("/")} role="link" alt="FastFin Logo">
            {logo}
          </span>
        </div>
        {Object.values(DashboardRoutesLinks).includes(location.pathname) && <div>
          <Link className="nav-menu flex"
            to={RoutesLink?.landingPage}
          >
            <img src={arrowIcon} className="rotate-180" />
            Website</Link>
        </div>}
        <nav className="header-desktop-menubar">
          <ul className="flex">
            {Object.values(DashboardRoutesLinks).includes(location.pathname) ?
              <DesktopNavbarList nav={DashboardMenuItems} />
              :
              <DesktopNavbarList nav={menuItems} />}
          </ul>
        </nav>
        <LoginHeaderContainer />
      </div>
      <MobileNavbar mobileMenu={mobileMenu} setmobileMenu={setmobileMenu}>
        <nav className="header-mobile-menubar">
          <ul className="flex menu-list">
            {menuItems.map((item, index) => (
              <li key={index} className="header-mobile-menu">
                <NavLink
                  className="nav-menu" // TODO :::: text should be 16px
                  to={item.link}
                  activeClassName="active"
                >
                  <span className="menu-tital-icon">{item?.icon}</span>
                  <span className="menu-tital-mobile">{item?.title}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </MobileNavbar>
    </>
  );
};

export default Navbar;
